export const LIST_SADDLE_FAVORITES = /* GraphQL */ `
  query listSaddleFavorites {
    listSaddleFavorites {
      createdAt
      horseId
      saddleId
      score
      updatedAt
      userId
      brandName
      saddle {
        pk
        sk
        type
        brandName
        createdAt
        discipline
        manufacturerMeasurements {
          gulletWidth
          gulletHeight
          barAngle
        }
        measurements {
          gulletWidth
          gulletHeight
          barAngle
        }
        newOrUsed
        price
        photo
        productTitle
        gallery
        quantity
        size
        status
        description
        score
        updatedAt
        variantId
        userId
      }
    }
  }
`;

export const LIST_SADDLE_FAVOURITES_BY_USER = /* GraphQL */ `
  query ListUserSaddleFitFavorites {
    listUserSaddleFitFavorites {
      count
      items {
        createdAt
        discipline
        horseId
        isFavorite
        newOrUsed
        saddleId
        score
        updatedAt
        userId
        saddle {
          amountOfTooling
          availability
          backBilletLatigo
          brandName
          cantle
          cantleHeight
          color
          conchoType
          condition
          createdAt
          description
          discipline
          fendersLeathersCutLength
          finishedHornHeight
          finishedSeatSize
          fleece
          frontBilletLatigo
          frontCinch
          gullet
          gulletWidth
          hardwareType
          hornCapWidth
          id
          maker
          makerLocation
          material
          model
          newOrUsed
          photo
          price
          rearCinch
          riggingType
          saddleFitNumber
          scannedAt
          serialNumber
          size
          skirtLength
          status
          stirrups
          strings
          style
          swellWidth
          title
          treeType
          treeWarranty
          type
          typeOfTooling
          unTooledPortionsTexture
          updatedAt
          userId
          weight
          yearOfManufacture
        }
      }
    }
  }
  # query SaddleFavoritesByUserQuery {
  #   listSaddleFavouriteByUser {
  #     createdAt
  #     horseId
  #     saddleId
  #     updatedAt
  #     saddle {
  #       amountOfTooling
  #       availability
  #       backBilletLatigo
  #       brandName
  #       cantle
  #       cantleHeight
  #       color
  #       conchoType
  #       condition
  #       createdAt
  #       description
  #       discipline
  #       fendersLeathersCutLength
  #       finishedHornHeight
  #       finishedSeatSize
  #       fleece
  #       frontBilletLatigo
  #       frontCinch
  #       gullet
  #       gulletWidth
  #       hardwareType
  #       hornCapWidth
  #       id
  #       maker
  #       makerLocation
  #       material
  #       model
  #       newOrUsed
  #       photo
  #       price
  #       rearCinch
  #       saddleFitNumber
  #       serialNumber
  #       scannedAt
  #       size
  #       skirtLength
  #       status
  #       stirrups
  #       strings
  #       style
  #       swellWidth
  #       title
  #       treeType
  #       treeWarranty
  #       type
  #       typeOfTooling
  #       unTooledPortionsTexture
  #       updatedAt
  #       weight
  #       yearOfManufacture
  #       riggingType
  #     }
  #   }
  # }
`;
